import { render, staticRenderFns } from "./ReservationsStart.vue?vue&type=template&id=c64d55f2&scoped=true"
import script from "./ReservationsStart.vue?vue&type=script&lang=js"
export * from "./ReservationsStart.vue?vue&type=script&lang=js"
import style0 from "./ReservationsStart.vue?vue&type=style&index=0&id=c64d55f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d55f2",
  null
  
)

export default component.exports